import { render, unmount } from 'rc-util/lib/React/render';
const defaultReactRender = (node, container) => {
    render(node, container);
    return () => {
        return unmount(container);
    };
};
let unstableRender = defaultReactRender;
/**
 * @deprecated Set React render function for compatible usage.
 * This is internal usage only compatible with React 19.
 * And will be removed in next major version.
 */
export function unstableSetRender(render) {
    unstableRender = render;
}
export function getReactRender() {
    return unstableRender;
}
